t = require('app/scripts/views/internal/teacup-with-helpers')('org_export')

module.exports = ->
  t.div '.window-module.org-export-header', ->

    t.button '.org-export-header-button.primary.js-create-new-export', ->
      t.format 'create-new-export'

    t.div '.org-export-header-options.u-clearfix', ->
      t.div '.check-div.check-div-inline', ->
        t.input { id: 'includeAttachments', type: 'checkbox' }
        t.label '.quiet.u-inline.u-font-weight-normal', { for: 'includeAttachments' }, ->
          t.format 'include-raw-attachments-ellipsis'

    t.p '.quiet.org-export-header-text', ->
      t.mustacheBlock 'hasCSV', ->
        t.format 'downloads-will-be-in-a-zip-format-that-includes-members-boards-and-all-other-data-in-csv-and-json-formats-if-you-choose-to-include-raw-attachments-they-will-be-in-their-native-format-otherwise-they-will-include-a-link-to-the-version-in-trello'
      t.mustacheBlockInverted 'hasCSV', ->
        t.format 'downloads-will-be-in-a-zip-format-that-includes-members-boards-and-all-other-data-in-json-format-if-you-choose-to-include-raw-attachments-they-will-be-in-their-native-format-otherwise-they-will-include-a-link-to-the-version-in-trello'

  t.div '.window-module.org-export-list', ->

    t.div '.window-module-title', ->
      t.span '.window-module-title-icon.icon-lg.icon-archive'
      t.h3 ->
        t.format 'exports'

    t.div '.u-gutter.u-clearfix.js-list-exports'

